import moment from 'moment/moment'
import TagManager from 'react-gtm-module'
import { QuoteDataType } from '../../types'
import { FUNNEL_STEP_NUMBER_MAP } from './constants'
import { FunnelStep } from './types'

export function sendFunnelStepGTM(
  quote: QuoteDataType,
  funnelStep: FunnelStep,
  label: string,
  isSubmit?: boolean
): void {
  const daysLeft = moment(quote.itinerary?.expireDate)
    .startOf('day')
    .diff(moment(Date.now()).startOf('day'), 'days', true)

  TagManager.dataLayer({
    dataLayer: {
      event: isSubmit ? 'offer_submit' : 'funnel_step',
      label,
      funnel_name: 'online omgeving',
      funnel_step: FUNNEL_STEP_NUMBER_MAP[funnelStep],
      step_name: funnelStep,
      destination: quote.itinerary?.destinations,
      trip: quote.itinerary?.packageName || undefined,
      trip_id: quote.itinerary?.packageId || undefined,
      date: quote.itinerary?.startDate,
      number_of_days: quote.itinerary?.days.length,
      total_price: quote.itinerary?.totalCosts,
      number_of_persons: quote.itinerary?.travellers,
      price_per_person: quote.itinerary ? quote.itinerary.totalCosts / quote.itinerary.travellers : undefined,
      offer_id: quote.itinerary?.opportunityId,
      offer_state: quote.itinerary?.status,
      offer_validity: daysLeft || undefined,
    },
  })
}
